module.exports = __webpack_public_path__ + "static/media/ahorros.e098e936.svg";